module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"satelitemap":"Satellite map","standardmap":"Standard map"},"de":{"satelitemap":"Satelliten Karte","standardmap":"Standard Karte"},"fr":{"satelitemap":"Carte satellite","standardmap":"Carte standard"},"it":{"satelitemap":"Carto Satelitte","standardmap":"Carto Normalo"}}')
  delete Component.options._Ctor
}
